<template>
  <Loading v-if="!placementTest || !results || !results.answers" />

  <div v-else class="placementTest">
    <h1>
      {{ placementTest.name }} -
      {{ $t("test level", { level: placementTest.level }) }}
      <span class="titleScore">
        {{ $t("student.placement score", { score: results.score }) }}
      </span>
    </h1>
    <h2>
      {{ results.user.name }}: {{ formatDatetime(results.created) }} ({{
        formatFromNow(results.created)
      }})
    </h2>

    <div class="controls">
      <label>{{ $t("Hide correct ones") }}</label
      ><van-switch v-model="hideCorrect" />
    </div>

    <div
      class="placementTestRow"
      v-for="({ id, question, answer_selected, is_correct },
      index) in results.answers"
      :key="id"
      v-show="!mistakeOnly || (mistakeOnly && !is_correct)"
    >
      <div class="question">
        <div class="questionNumber">{{ index + 1 }}/</div>
        <div class="questionBody">
          <div
            class="sentence"
            v-for="(sentence, idxSentence) in parseSentence(question.question)"
            :key="`sentence-${idxSentence}`"
          >
            <i class="fas fa-user-circle" v-if="idxSentence % 2 === 0"></i>
            <i class="far fa-user-circle" v-else></i>
            <span style="padding-left: 10px;">{{ sentence }}</span>
          </div>
        </div>
      </div>

      <div
        class="answer"
        v-for="(answer, idxAnswer) in question.answers"
        :key="`answer-${idxAnswer}`"
      >
        <div class="checkbox">
          <i class="far fa-check-square" v-if="answer_selected == answer" />
          <i class="far fa-square" v-else />
        </div>
        <div
          class="answerOption"
          :class="{
            mistake: !is_correct && answer_selected == answer,
            correct: !is_correct && answer == question.correct_answer
          }"
        >
          {{ answer }}
        </div>
      </div>
    </div>
    <div class="stats-box-area">
      <template class="results" v-if="Object.keys(results).length > 0">
        <PlacementTestGrading />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import PlacementTestGrading from "@/components/PlacementTestGrading";
import Loading from "@/components/Loading";
import formatTS from "@/mixins/momentMixin";

export default {
  name: "ReviewPlacementTestResult",
  components: { PlacementTestGrading, Loading },
  mixins: [formatTS],
  data() {
    return {
      hideCorrect: false,
      showAllAnswers: true
    };
  },
  computed: {
    ...mapState("placementTest", ["placementTest", "testResults"]),
    questions() {
      return this.placementTest.questions;
    },
    results() {
      return this.testResults;
    },
    mistakeOnly() {
      return this.hideCorrect;
    }
  },
  methods: {
    ...mapMutations("setting", ["SET_PAGE_TITLE"]),
    ...mapActions("placementTest", [
      "getPlacementTest",
      "getPlacementTestResult"
    ]),
    ...mapMutations("placementTest", ["RESET_TEST_RESULTS"]),
    parseSentence(sentence) {
      if (sentence) {
        return sentence
          .trim()
          .split("- ")
          .filter(i => i != "");
      }
      return [];
    }
  },
  created() {
    this.SET_PAGE_TITLE(this.$t("Placement test result"));
    let resultId = this.$route.params.result_id;
    this.getPlacementTestResult(resultId);
  },
  destroyed() {
    this.RESET_TEST_RESULTS();
  }
};
</script>

<style lang="scss">
.placementTest {
  padding: 16px;
  height: calc(100vh - 205px) !important;
  h2 {
    margin: 12px 0;
  }
  .controls {
    display: flex;
    label {
      align-self: center;
      padding: 0 6px;
    }
    float: right;
  }
  .titleScore {
    float: right;
  }
  .placementTestRow {
    &:first-child {
      border-top: 1px solid #e3e3e3;
    }
    &.missing {
      border: 1px solid rgba(255, 0, 0, 0.6);
      border-bottom: none;
    }

    padding: 20px;
    border-bottom: 1px solid #e3e3e3;
    .question,
    .answer {
      padding: 10px;
    }
    .question {
      display: flex;
      .questionNumber {
        width: 30px;
        font-weight: bold;
      }
      .questionBody {
        .sentence {
          padding-bottom: 10px;
          display: flex;
          align-items: center;
        }
      }
    }
    .answer {
      padding-left: 40px;
      .checkbox {
        padding-left: 10px;
        padding-right: 10px;
      }
      display: flex;

      .answerOption {
        &.correct {
          border-bottom: 7px solid rgba(0, 128, 0, 0.5);
        }
        &.mistake {
          text-decoration: line-through solid red;
        }
      }
    }
  }

  .stats-box-area {
    position: absolute;
    justify-content: center;
    bottom: 0;
    background: white;
    width: 100%;
    height: 91px;
    left: 0px;
    border-top: 1px solid #e3e3e3;
    text-align: center;
    display: flex;
    justify-items: center;
    padding: 20px;
  }
}
</style>
